const Foot_questions = [
  {
    question: "How is ##name## being evaluated today?",
    sub: "",
    type: "radio",
    telehealth:
      "form1[0].#subform[0].#subform[1].Public2507Questions[0].HowExamCOnducted[0]",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "",
    },
    questions: [
      {
        label: "How was the examination conducted?",
        title: "",
        subMain: "",
        sub: "",
        radioGroup:
          "form1[0].#subform[0].#subform[1].Public2507Questions[0].RadioButtonList[2]",
        options: [
          {
            main: "In-Person Exam",
            dbqName: "1",
            sub: "",
          },
          {
            main: "Video Telehealth",
            dbqName: "2",
            sub: "",
          },
        ],
        answer: "In-Person Exam",
      },
    ],
  },
  {
    question: "Is ##name## regularly seen as a patient in your clinic?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "0",
    },
    presidence: "Yes",
    radioGroup:
      "form1[0].#subform[0].#subform[1].Public2507Questions[0].RadioButtonList[1]",
    ref: 0,
    dbqName_yes: "1",
    dbqName_no: "2",
    answer: "",
  },
  {
    question: "Did you review any of the patients records for this condition?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "EVIDENCE REVIEW",
      number: "0",
    },
    presidence: "Yes",
    radioGroup:
      "form1[0].#subform[0].#subform[1].PublicEvidenceReview[0].RadioButtonList[0]",
    ref: 0,
    dbqName_yes: "2",
    dbqName_no: "1",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please identify the evidence reviewed and the date range",
    textdbqName:
      "form1[0].#subform[0].#subform[1].PublicEvidenceReview[0].IdentifyEvidence[0]",
    textanswer: "",
  },
  {
    question: "Does ##name## have pain on use of the feet?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "3",
      title: "FLATFOOT (PES PLANUS)",
      number: "3A",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[6].DBQ3a[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[6].rte4a[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[6].lft4a[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[6].bth4a[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[6].DBQ3a[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Does ##name## have pain on manipulation of the feet?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "3",
      title: "FLATFOOT (PES PLANUS)",
      number: "3B",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[6].DBQ3b[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[6].rte7[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[6].lft7[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[6].bth7[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[6].DBQ3b[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Does ##name## have pain accentuated on manipulation?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "3",
      title: "FLATFOOT (PES PLANUS)",
      number: "3B",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[6].DBQ3b2[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[6].rte8[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[6].lft8[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[6].bth8[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[6].DBQ3b2[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Is there indication of swelling on use?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "4",
      title: "FLATFOOT (PES PLANUS)",
      number: "3C",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[7].DBQ3c[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[7].rte10[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[7].lft10[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[7].bth10[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[7].DBQ3c[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Does ##name## have characteristic calluses?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "4",
      title: "FLATFOOT (PES PLANUS)",
      number: "3D",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[7].DBQ3d[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[7].rte11[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[7].lft11[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[7].bth11[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[7].DBQ3d[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Does ##name## have extreme tenderness of plantar surfaces on one or both feet?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "4",
      title: "FLATFOOT (PES PLANUS)",
      number: "3F",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[7].DBQ3f[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[7].rte12[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[7].lft12[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[7].bth12[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[7].DBQ3f[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Does ##name## have decreased longitudinal arch height of one or both feet on weight-bearing?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "4",
      title: "FLATFOOT (PES PLANUS)",
      number: "3G",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[7].DBQ3g[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[7].rte5[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[7].lft5[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[7].bth5[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[7].DBQ3g[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Is there objective evidence of marked deformity of one or both feet (pronation, abduction, etc.)?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "4",
      title: "FLATFOOT (PES PLANUS)",
      number: "3H",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[7].DBQ3h[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[7].rte10a[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[7].lft10a[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[7].bth10a[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[7].DBQ3h[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Is there marked pronation of one foot or both feet?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "4",
      title: "FLATFOOT (PES PLANUS)",
      number: "3I",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[7].DBQ3i[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[7].Right1[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[7].Left1[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[7].Both1[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[7].DBQ3i[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "For one or both feet, is the weight-bearing line over or medial to the great toe?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "5",
      title: "FLATFOOT (PES PLANUS)",
      number: "3J",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[8].DBQ3j[0]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[8].Right2[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[8].Left2[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[8].Both2[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[8].DBQ3j[1]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Is there a lower extremity deformity other than pes planus, causing alteration of the weight-bearing line?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "5",
      title: "FLATFOOT (PES PLANUS)",
      number: "3K",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[8].DBQ3k[0]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[8].Right3[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[8].Left3[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[8].Both3[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[8].DBQ3k[1]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Does ##name## have inward bowing of the Achilles' tendon (i.e., hindfoot valgus, with lateral deviation of the heel) of one or both feet?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "5",
      title: "FLATFOOT (PES PLANUS)",
      number: "3L",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[8].DBQ3l[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[8].Right4[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[8].Left4[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[8].Both4[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[8].DBQ3l[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Does ##name## have marked inward displacement and severe spasm of the Achilles' tendon (rigid hindfoot) on manipulation of one or both feet?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "5",
      title: "FLATFOOT (PES PLANUS)",
      number: "3M",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[8].DBQ3m[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[8].Right5[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[8].Left5[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[8].Both5[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[8].DBQ3m[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Has ##name## undergone non-surgical treatment for plantar fasciitis?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "5",
      title: "PLANTAR FASCIITIS",
      number: "4A",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[8].DBQ4a620[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[8].rte4a2[1]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[8].lft4a2[1]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[8].bth4a2[1]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[8].DBQ4a620[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Did the non-surgical treatment relieve the symptoms?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "5",
      title: "PLANTAR FASCIITIS",
      number: "4B",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[8].DBQ4a[0]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[8].rte4a2[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[8].lft4a2[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[8].bth4a2[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[8].DBQ4a[1]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Has ##name## undergone surgical treatment for plantar fasciitis?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "6",
      title: "PLANTAR FASCIITIS",
      number: "4C",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[9].#subform[10].DBQ4c162[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[9].#subform[10].rte4a2[2]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[9].#subform[10].lft4a2[2]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[9].#subform[10].bth4a2[2]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[9].#subform[10].DBQ4c162[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Did the surgical treatment relieve the symptoms?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "6",
      title: "PLANTAR FASCIITIS",
      number: "4D",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[9].#subform[10].DBQ4b[0]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[9].#subform[10].rte4a223[0]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[9].#subform[10].lft4a223[0]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[9].#subform[10].bth4a223[0]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[9].#subform[10].DBQ4b[1]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "If the ##name## has not undergone surgical treatment, was the Veteran recommended for surgical intervention, but was not a surgical candidate?",
    sub: "If yes, indicate side affected",
    type: "checkbox",
    multi: false,
    small: true,
    show: true,
    cols: 2,
    section: {
      page: "6",
      title: "PLANTAR FASCIITIS",
      number: "4E",
    },
    questions: [
      {
        main: "Yes",
        dbqName: "form1[0].#subform[9].#subform[10].DBQ4e420[1]",
        answer: "",
        multi: false,
        subAnswer: "",
        textarea: false,
        showSubItems: false,
        subItems: [
          {
            main: "Right",
            dbqName: "form1[0].#subform[9].#subform[10].rte4a223[1]",
            answer: "",
          },
          {
            main: "Left",
            dbqName: "form1[0].#subform[9].#subform[10].lft4a223[1]",
            answer: "",
          },
          {
            main: "Both",
            dbqName: "form1[0].#subform[9].#subform[10].bth4a223[1]",
            answer: "",
          },
        ],
      },
      {
        main: "No",
        dbqName: "form1[0].#subform[9].#subform[10].DBQ4e420[0]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Does ##name## have any functional loss of the foot/feet due to plantar fasciitis?",
    sub: "If yes indicate sides and describe",
    type: "radioTiles",
    multi: false,
    show: true,
    textarea: false,
    small: true,
    cols: 2,
    section: {
      page: "6",
      title: "PLANTAR FASCIITIS",
      number: "4F",
    },
    questions: [
      {
        main: "Right side",
        dbqName:
          "form1[0].#subform[9].#subform[10].DBQ4c[1],form1[0].#subform[9].#subform[10].rte4a2233[0]",
        answer: "",
        textarea: true,
        textdbqName: "form1[0].#subform[9].#subform[10].describelower4c[0]",
        placeholder: "Please describe",
        textAnswer: "",
      },
      {
        main: "Left side",
        dbqName:
          "form1[0].#subform[9].#subform[10].DBQ4c[1],form1[0].#subform[9].#subform[10].lft4a2233[0]",
        answer: "",
        textarea: true,
        textdbqName: "form1[0].#subform[9].#subform[10].describelower4c[0]",
        placeholder: "Please describe",
        textAnswer: "",
      },
      {
        main: "Both sides",
        dbqName:
          "form1[0].#subform[9].#subform[10].DBQ4c[1],form1[0].#subform[9].#subform[10].bth4a2233[0]",
        answer: "",
        textarea: true,
        textdbqName: "form1[0].#subform[9].#subform[10].describelower4c[0]",
        placeholder: "Please describe",
        textAnswer: "",
      },
      {
        main: "No functional loss observed",
        dbqName: "form1[0].#subform[9].#subform[10].DBQ4c[0]",
        answer: "",
      },
    ],
    answer: "",
    textAnswer: "",
  },
  {
    question: "Additional Comments",
    sub: "",
    optional: true,
    type: "textarea",
    show: true,
    section: {
      page: "14",
      title: "REMARKS",
      number: "20A",
    },
    options: [],
    dbqName: "form1[0].#subform[24].#subform[25].Comments[2]",
    answer: "",
  },
];

export default Foot_questions;
